const ONE_SECOND = 1000;
export const ONE_MINUTE = 60 * ONE_SECOND;
export const ONE_HOUR = 60 * ONE_MINUTE;

export const DAYS_IN_YEAR = 365;
export const MONTH_PER_YEAR = 12;
